import { Input } from "common/InputForm";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toastMessage } from "utils/toastMessage";
import usePasswordToggle from "common/UsePasswordToggle";
import useButtonLoader from "hooks/useButtonLoader";
import { removeErrorFields, ValidateInput } from "validation";
import { userProfile } from "validation/schema/userProfile";
import { getToken, removeToken } from "config/axiosInstance";
import { changePasswordAPi } from "services/profile";
import { changePasswordSubAdminApi } from "services/subAdmin";

const ChangePassword = () => {
  // set all value
  const [inputData, setInputData] = useState({});
  const [error, setError] = useState({});
  const adminDetails = localStorage.getItem('admin-detail');
  const admin = adminDetails ? JSON.parse(adminDetails) : null;

  // Hook
  const [confirmInputType, icon] = usePasswordToggle();
  const [changePasswordButtonLoader, setChangePasswordButtonLoader] =
    useButtonLoader("Change Password");
  const navigateRoute = useNavigate();

  // Input change handler
  const changeHandler = (event) => {
    const { name, value } = event.target;
    setInputData({ ...inputData, [name]: value });
    setError((prevError) => removeErrorFields(prevError, name));
  };

  // Validate Input Data
  const validation = () => {
    const { errors, status } = ValidateInput(
      inputData,
      "changeUserPasswordSchema",
      userProfile,
      null
    );
    setError(errors);
    return status;
  };

  // check mis-match password
  const checkMisMatchPassword = () => {
    if (inputData?.newPassword !== inputData?.confirmPassword) {
      toastMessage("New Password and Confirm Password do not match. Please re-enter.", "warning", "changePassword");
      return false;
    }
    return true;
  };

  const changePasswordHandler = async (e) => {
    e.preventDefault();
    if (validation() && checkMisMatchPassword()) {
      try {
        const payLoad = {
          adminId: admin?._id,
          oldPassword: inputData?.oldPassword,
          password: inputData?.confirmPassword,
        }
        setChangePasswordButtonLoader(true);
        const res = await changePasswordSubAdminApi(payLoad)
        const { code, message } = res?.data;
        if (code === 200) {
          toastMessage(message, "success", "changePassword");
          // removeToken();
          // navigateRoute("/");
          setInputData({})
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setChangePasswordButtonLoader(false);
      }
    }
  };


  return (
    <>
      <div className="add_employee_wrap">
        <div className="breadcrumb">
          <ul>
            <li>
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li>Change Password</li>
          </ul>
        </div>

        <div className="add_employee _box">
          <div className="w-50">
            <div className="form_field_wrap">
              <div className="form_field has_icon">
                <Input
                  type="text"
                  placeholder="Enter Old Password"
                  label="Old Password"
                  name="oldPassword"
                  value={inputData?.oldPassword}
                  onChange={changeHandler}
                  error={error?.oldPassword}
                />
              </div>
            </div>

            <div className="form_field_wrap">
              <div className="form_field has_icon">
                <Input
                  type="text"
                  placeholder="Enter New Password"
                  label="New Password"
                  name="newPassword"
                  value={inputData?.newPassword}
                  onChange={changeHandler}
                  error={error?.newPassword}
                  extraError={error?.newPasswordErr}
                />
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field has_icon">
                <Input
                  type={confirmInputType}
                  placeholder="Enter Conform Password"
                  label="Conform Password"
                  name="confirmPassword"
                  value={inputData?.confirmPassword}
                  onChange={changeHandler}
                  error={error?.confirmPassword}
                  extraError={error?.confirmPasswordErr}
                />
                <span className="password_icons">{icon}</span>
              </div>
            </div>
            <div className="text-center">
              <button
                ref={changePasswordButtonLoader}
                className="button"
                onClick={changePasswordHandler}
              >
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
